<script>
export const group = 'Bottom'
</script>

<script setup>
import { computed, ref, onMounted, watch, nextTick } from 'vue'
import { cdnImageUrl } from '@dpgradio/creative'
import SquareMask from './shared/SquareMask.vue'
import HighlightWords from './text_animations/HighlightWords.vue'
import fallbackImage from './assets/willy-cover-placeholder.jpg'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const activeItem = ref(props.item)
const activeEdition = computed(() => activeItem.value.enrichment.track.activeEditions?.[0])
const thumbnail = computed(() => {
  return activeItem.value.enrichment.track?.thumbnail ? cdnImageUrl(activeItem.value.enrichment.track.thumbnail) : fallbackImage
})

const containerRef = ref(null)

const timelineImage = ref(null)
const timelineLineArtist = ref(null)
const timelineLineTitle = ref(null)
const timelineLineChartTitle = ref(null)
const timelineLineChartPosition = ref(null)

const timelineImageDisappear = ref(null)

const appear = (delay = 0) => {
  timelineLineArtist.value?.reversed(false)
  timelineLineTitle.value?.reversed(false)
  timelineLineChartTitle.value?.reversed(false)
  timelineLineChartPosition.value?.reversed(false)

  return gsapTimeline({ name: 'NowPlayingSmall' })
    .delay(delay)
    .add(timelineImage, '<')
    .add(timelineLineArtist, '<0.5')
    .add(timelineLineTitle, '>')
    .add(timelineLineChartTitle, '>')
    .add(timelineLineChartPosition, '>')
}

const disappear = () => {
  timelineLineArtist.value?.reversed(true)
  timelineLineTitle.value?.reversed(true)
  timelineLineChartTitle.value?.reversed(true)
  timelineLineChartPosition.value?.reversed(true)

  return gsapTimeline({ name: 'NowPlayingSmall - End' })
    .add(timelineLineTitle, '<')
    .add(timelineLineArtist, '>')
    .add(timelineImageDisappear, '>')
    .add(timelineLineChartTitle, '<')
    .add(timelineLineChartPosition, '<')
    .endInvisible(containerRef.value)
    .totalDuration(0.9)
}

const { onDisappear } = useDisappearable()

onMounted(appear)
onDisappear(disappear)

watch(
  () => props.item,
  async (newItem) => {
    await disappear()

    timelineImage.value = null
    timelineImageDisappear.value = null
    timelineLineArtist.value = null
    timelineLineTitle.value = null
    timelineLineChartTitle.value = null
    timelineLineChartPosition.value = null

    await nextTick()
    activeItem.value = newItem
    await nextTick()

    appear(1)
  }
)
</script>

<template>
  <div ref="containerRef" class="h-full w-full">
    <div :key="activeItem.enrichment.track.selectorCode" ref="contentElement" class="absolute bottom-0 p-safe flex items-end space-x-1 w-full">
      <SquareMask class="w-60 mr-12" @timeline="timelineImage = $event" @disappearTimeline="timelineImageDisappear = $event">
        <img :src="thumbnail" class="w-full h-full object-cover" />
      </SquareMask>
      <div class="flex-1 -space-y-3">
        <HighlightWords :text="activeItem.enrichment.track.artist.name" class="font-anton text-[85px]" @timeline="timelineLineArtist = $event" />
        <HighlightWords :text="activeItem.enrichment.track.title" class="font-anton text-[85px] line-clamp-1" @timeline="timelineLineTitle = $event" />
      </div>
      <div v-if="activeEdition" class="text-right pl-8 pb-2">
        <div class="flex justify-end">
          <HighlightWords :text="`#${activeEdition.position}`" class="font-rift font-bold text-[50px] -mb-1" textColor="#087E8B" @timeline="timelineLineChartPosition = $event" />
        </div>
        <HighlightWords :text="activeEdition.list.name" class="font-rift font-bold text-[50px]" @timeline="timelineLineChartTitle = $event" />
      </div>
    </div>
  </div>
</template>
